module.exports = __webpack_public_path__ + "static/media/key_padlock.ede93cf3.ico";